export default __webpack_public_path__ + "static/media/Ellipse.16574e2d.svg";